import * as React from 'react';
import { Button } from 'antd';
import gamesList from './gamesList';
import { Card } from "antd";
import * as Icons from '@ant-design/icons';
import VisualMemory from '../../../games/VisualMemory/VisualMemory';
import { ChooseGameBox, GamesListBox, GameBox, CurrentGameBox } from './ChooseGame.css';
import ReactionTime from '../../../games/ReactionTime/ReactionTime';
import AimTraining from '../../../games/AimTraining/AimTraining';
import SequenceMemory from '../../../games/SequenceMemory/SequenceMemory';
import ChimpTest from '../../../games/ChimpTest/ChimpTest';

const Games = {
    vm: <VisualMemory />,
    rt: <ReactionTime />,
    at: <AimTraining />,
    sm: <SequenceMemory />,
    ct: <ChimpTest />,
};

declare global {
    interface Window {
        userId: string;
    }
}

const ChooseGame = () => {
    const { useState } = React;
    const [currentGameId, setCurrentGameId] = useState('');
    const [title, setTitle] = useState('CHOOSE GAME');

    const renderGame = (): JSX.Element => {
        if (currentGameId === 'vm')
            return Games.vm;
        if (currentGameId === 'rt')
            return Games.rt;
        if (currentGameId === 'at')
            return Games.at;
        if (currentGameId === 'sm')
            return Games.sm;
        if (currentGameId === 'ct')
            return Games.ct;
        return Games.vm;
    };

    const handleClickGame = (id: string, name: string) => {
        setCurrentGameId(id);
        setTitle(name);
    };

    const handleBack = () => {
        setCurrentGameId('');
        setTitle('CHOOSE GAME');
    };

    const renderChooseGameHeader = () => {
        return <div>{currentGameId !== '' ? <Button onClick={handleBack} style={{marginRight: 10}} type="dashed">BACK</Button> : <Icons.PlayCircleOutlined />} {title}</div>
    };

    return (
        <Card bordered title={renderChooseGameHeader()} style={{margin: "16px 16px"}}>
            <ChooseGameBox>
                {currentGameId !== '' ? <CurrentGameBox>{renderGame()}</CurrentGameBox> :
                <GamesListBox>
                    {gamesList.map((game) => <GameBox>
                        <Button type="primary" onClick={() => handleClickGame(game.id, game.name)}>
                            {game.name}
                        </Button>
                    </GameBox>)}
                </GamesListBox>}
            </ChooseGameBox>
        </Card>
    );
};

export default ChooseGame;